import ConnectionType from '../ygdrasil/enums/ConnectionType'

const MS_INTEGRATIONS_TUTORIAL_URL = 'https://stonly.com/sl/sv/5255c493-70a4-4fe1-9eaf-4fc1b0f4bb5d/Steps/2127554'
const GOOGLE_INTEGRATIONS_TUTORIAL_URL = 'https://stonly.com/sl/en/114cee43-31be-4586-918a-4f85be05bba5/Steps/2134486'
export const openIntegrationsTutorial = (connectionType: ConnectionType) =>
  window.open(
    connectionType === ConnectionType.EXCEL_ONLINE ? MS_INTEGRATIONS_TUTORIAL_URL : GOOGLE_INTEGRATIONS_TUTORIAL_URL,
    '_blank'
  )
